import React from "react";
import { useQuery } from "react-query";
import { Container } from "reactstrap";
import { HeaderSection } from "../../components/shared/HeaderSection";
import { CardTransport } from "../../components/tourism/CardTransport";

import ROUTES from "../../routes/routes";
import { getTransport } from "../../services/tourismService";

const Servers = () => {
  const colorTransporte = "#FED32F";
  const { isLoading, isError, data, isFetching } = useQuery(
    "transport",
    getTransport
  );

  if (isLoading) return <p>Cargando</p>;
  if (isFetching) return <p>Loading feaching...</p>;
  if (isError) return <p>error</p>;

  return (
    <>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver a Turismo"}
        bgBtnColor={colorTransporte}
      />
      <Container>
        <h3 className="subheader-main" style={{ borderColor: colorTransporte }}>
          Transporte público
        </h3>

        <CardTransport data={data} routeDetail={ROUTES.ATRACTIVE_DETAIL} />
      </Container>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver a Turismo"}
        bgBtnColor={colorTransporte}
      />
    </>
  );
};

export default Servers;
